import { useBlocker } from '@tanstack/react-router';
import { FeatureFlag } from '@mews-commander/enums';
import { useFeatureFlag } from '@mews/framework';
import { UnsavedChangesDialog } from '../../dialog';
import { useFormObserver } from './useFormObserver';

/** EXPERIMENTAL
 *  Adds a unsaved changes dialog to forms.
 *  It polls the forms for dirty state and will re-query for forms if the state changes.
 *
 *  This component is experimental and can change in the future.
 *  If we find this UX fix does not meaningfully impact TTO (time-to-onboard),
 *  we will remove this. If this flow _does_ work, we will either migrate the
 *  relevant BE pages or incorporate this into how the BE forms are rendered, or
 *  some other third way that we're happy to maintain.
 *
 *  Follow up with sean.newell and ricardo.dominguez on October 5st, 2024 for removal/action (we
 *  intend to act sooner than that).
 *
 *  @deprecated as this is a temporary, hacky solution to prove if it has a positive impact on TTO
 */
export function UnsavedChangesObserver() {
    const hasEnhancedUx = useFeatureFlag(FeatureFlag.unsavedChangesDialogInBeForms);
    if (!hasEnhancedUx) {
        return null;
    }

    return <UnsavedChangesObserverInternal />;
}

export function UnsavedChangesObserverInternal() {
    const { hasDirtyForms, isDeleteAction } = useFormObserver();
    const { proceed, reset, status } = useBlocker({
        condition: hasDirtyForms && !isDeleteAction,
    });

    if (!reset || !proceed) {
        return null;
    }

    return <UnsavedChangesDialog active={status === 'blocked'} onCancel={reset} onDiscardChanges={proceed} />;
}
